import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { Popover } from 'reactstrap'

import classes from './FiltersPopover.module.scss'

const FiltersPopover = ({ isOpen, toggle, target, pendingCount, onApply, onClearAll, children }) => {
  const { t } = useTranslation()

  return (
    <Popover
      placement='bottom-start'
      isOpen={isOpen}
      target={target}
      toggle={toggle}
      trigger='legacy'
      className={classes.popoverContainer}
    >
      <div className={classNames(classes.popover, 'd-flex flex-column')}>
        <div className={classes.scrollContent}>
          <div className='d-flex align-items-center justify-content-between'>
            <h6 className={classNames(classes.title, 'mb-0')}>{t('common.filtersPopover.title')}</h6>
            <button className={classes.clearAllButton} onClick={onClearAll}>{t('common.filtersPopover.clearAll')}</button>
          </div>
          <hr className={classNames(classes.sectionDivider, 'my-2')} />
          {children}
        </div>

        <div className={classNames(classes.applyFooter, 'd-flex align-items-center justify-content-end')}>
          {pendingCount > 0 && (
            <span className={classes.pendingText}>{t('common.filtersPopover.pendingChanges', { count: pendingCount })}</span>
          )}
          <button className={classes.applyButton} onClick={onApply} disabled={pendingCount === 0}>{t('common.action.apply')}</button>
        </div>
      </div>
    </Popover>
  )
}

FiltersPopover.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  target: PropTypes.string.isRequired,
  pendingCount: PropTypes.number.isRequired,
  onApply: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default FiltersPopover
